import { motion } from "framer-motion";
import closingVideo from "@/assets/coressen-global.mp4";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const ClosingCTA = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden" style={{ background: "linear-gradient(180deg, #0d1a3d 0%, #0f2057 100%)" }}>
      {/* Background gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-20" style={{ backgroundColor: "#2563eb" }} />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full blur-3xl opacity-15" style={{ backgroundColor: "#3b82f6" }} />
      </div>

      <div className="container px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-20 max-w-6xl mx-auto">
          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex-1 text-center lg:text-left max-w-xl"
          >
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-white">
              El valor de tu trayectoria merece{" "}
              <span className="bg-clip-text text-transparent" style={{ backgroundImage: "linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%)" }}>una marca a su altura.</span>
            </h2>

            <p className="text-lg md:text-xl text-white/70 leading-relaxed mb-8">
              Si tenés trayectoria y estás listo para convertir tu éxito en un
              activo de autoridad, iniciemos la conversación.
            </p>

            <motion.a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white font-semibold rounded-full hover:shadow-[0_8px_30px_hsl(221,83%,53%/0.4)] transition-all duration-300 hover:scale-105"
            >
              Hablar con un Consultor
            </motion.a>
          </motion.div>

          {/* Video */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex-shrink-0"
          >
            <div className="relative w-[280px] md:w-[320px] aspect-[9/16] rounded-2xl overflow-hidden shadow-2xl border border-[#3b82f6]/30">
              {/* Decorative glow */}
              <div className="absolute -inset-1 bg-gradient-to-br from-[#3b82f6]/25 to-transparent rounded-2xl blur-xl opacity-60" />

              <video
                src={closingVideo}
                autoPlay
                loop
                muted
                playsInline
                className="relative w-full h-full object-cover rounded-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;